import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { getBaseUrl } from './getBaseUrl';

export const useGetCurrentUrl = () => {
	const [currentUrl, setCurrentUrl] = useState('');

	const pathname = usePathname();
	const baseUrl = getBaseUrl();

	const url = `${baseUrl}${pathname}`;

	useEffect(() => {
		if (typeof window !== 'undefined') {
			setCurrentUrl(url);
		}
	}, []);

	return currentUrl;
};
